import { appConstants } from "./appConstants";

let config = null;

export const initExternalConfig = () => (config = { ...window.__ENV__.BFF_CONFIG });
export const bffRoutes = {
  getGBTokenValidate: () => `${config.bff}${appConstants.BFF_GB_TOKEN_VALIDATE}`,
  getTokenGenerate: () => `${config.bff}${appConstants.BFF_TOKEN_GENERATE}`,
  getTokenUpdate: () => `${config.bff}${appConstants.BFF_TOKEN_UPDATE}`,
  getLogout: () => `${config.bff}${appConstants.BFF_LOGOUT}`,
  getLogoutFinal: () => `${config.bff}${appConstants.BFF_LOGOUT_FINAL}`,
  getSaveDocuments: () => `${config.bff}${appConstants.SAVE_DOCUMENTS}`,
  getRefreshCookie: () => `${config.bff}${appConstants.BFF_REFRESH_COOKIE}`,
  getPdfNameCheckEnglish: () => `${appConstants.PDF_NAME_CHECK_ENGLISH}`,
  getPdfNameCheckFrench: () => `${appConstants.PDF_NAME_CHECK_FRENCH}`,
};

